module.exports = __webpack_public_path__ + "img/stechoq-logo.99bc5141.svg";